<template>
  <section class="booking-calendar-week-desktop padding-bottom-xs-2">
    <BookingCalendarWeekDesktopHeader />
    <div class="row">
      <div class="book-time-dates-wrapper book-time-dates-desktop">
        <div
          class="book-time-single-date"
          v-for="weekday in dates.active.weekdays"
          :class="{
            'book-time-single-date-current':
              dates.current.niceDate == weekday.niceDate,
          }"
          :key="'booking-calendar-week-desktop-single-date-' + weekday.niceDate"
        >
          <div class="book-time-single-date-headline">
            <p>
              <span
                v-if="
                  dates.current.niceDate == weekday.niceDate &&
                  getRealWeekday != 'Sunday'
                "
                >Idag – </span
              >{{ weekday.name }}
              {{ weekday.dayOfMonth }}
              {{ weekday.monthShortName }}
            </p>
          </div>
          <div class="book-time-single-date-content">
            <div
              v-if="ui.loading.times && weekday.name == 'tor'"
              class="calendar-loading-spinner booking-calendar-week-item-padding"
            >
              <img
                class="loading-spinner-nk"
                src="/wp-content/themes/nordiskakliniken/dist/images/loading-spinner.svg"
              />
            </div>

            <a
              href="#"
              v-for="slot in weekday.activeTimes"
              @click.prevent="setSelectedSlot(slot)"
              :class="{
                selected:
                  selectedSlot &&
                  String(selectedSlot.date) === String(slot.date) &&
                  String(selectedSlot.time) === String(slot.time) &&
                  String(selectedSlot.location_id) === String(slot.location_id) &&
                  String(selectedSlot.terapeut_id) === String(slot.terapeut_id),
              }"
              v-if="
                !ui.loading.times &&
                activities.selected &&
                slot.terapeut_id != 8999999999
              "
              :key="
                'booking-calendar-week-desktop-' + slot.terapeut_id + slot.time
              "
            >
              <div class="book-time-single-slot">
                <p class="book-time-single-slot-time">
                  {{ slot.time }}
                </p>
                <p
                  class="book-time-single-slot-practitioner"
                  v-html="formatProviderName(slot.terapeut_sign)"
                ></p>
                <p
                  class="book-time-single-slot-practitioner book-time-location book-time-location-desktop"
                >
                  {{ slot.location_short_name }}
                </p>
              </div>
            </a>
            <div
              class="no-available-times booking-calendar-week-item-padding"
              v-if="
                !weekday.activeTimes.length &&
                !ui.loading.times &&
                activities.selected
              "
            >
              <p>Inga tider</p>
            </div>
            <div
              class="booking-calendar-week-item-padding"
              v-if="
                !weekday.activeTimes.length &&
                !ui.loading.times &&
                !activities.selected
              "
            >
              <p>Välj behandling för att se tider</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BookingCalendarWeekDesktopHeader from './BookingCalendarWeekDesktopHeader.vue';

export default {
  components: {
    BookingCalendarWeekDesktopHeader,
  },
  computed: {
    ...mapState(['activities', 'dates', 'ui', 'selectedSlot']),
    ...mapGetters(['formatProviderName']),
    selectedProvider() {
      return this.$store.state.providers.selected;
    },
  },
  methods: {
    ...mapActions(['setSelectedSlot', 'getRealWeekday']),
  },
  watch: {
    /* Workaround to make sure the correct times are displayed when changing the provider */
    selectedProvider(newProvider, oldProvider) {
      this.$forceUpdate();
    },
    // Also force update when we jump weeks (e.g. via "Hitta nästa lediga tid") or when loading completes.
    // Without this, the DOM can get stuck showing "Inga tider" until another interaction triggers a rerender.
    'dates.active.weekStartDate'() {
      this.$forceUpdate();
    },
    'ui.loading.times'(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.$forceUpdate();
      }
    },
  },
};
</script>
